import { Component } from "@angular/core";
import { ContainerBlockComponent } from "@sdk/lib/container-block/container-block/container-block.component";

@Component({
    selector: "app-uplift-user-container-block",
    templateUrl: "./uplift-user-container-block.component.html",
    styleUrls: ["./uplift-user-container-block.component.css"]
})
export class UpliftUserContainerBlockComponent extends ContainerBlockComponent {}
